import React from "react";
import styled from "styled-components/macro";

const UnitMoveButton = ({ onClick }) => {
  return (
    <Wrapper>
      <ArrowUp
        onClick={() => {
          onClick && onClick("up");
        }}
      />
      <ArrowDown
        onClick={() => {
          onClick && onClick("down");
        }}
      />
      <ArrowRight
        onClick={() => {
          onClick && onClick("right");
        }}
      />
      <ArrowLeft
        onClick={() => {
          onClick && onClick("left");
        }}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  width: 70px;
  height: 70px;
  position: relative;
  flex-direction: column;
  border-radius: 50%;
  box-shadow: 2px 2px 5px #bababa;
  background-color: #a1a0a0;
  opacity: 0.45;
`;

const ArrowUp = styled.div`
  width: 0;
  height: 0;
  position: absolute;
  top: 0;
  padding-top: 8px;
  margin-left: auto;
  margin-right: auto;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 10px solid white;
  left: 0;
  right: 0;
`;

const ArrowDown = styled.div`
  width: 0;
  height: 0;
  position: absolute;
  bottom: 0;
  padding-bottom: 8px;
  margin-left: auto;
  margin-right: auto;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 10px solid white;
  left: 0;
  right: 0;
`;

const ArrowRight = styled.div`
  width: 0;
  height: 0;
  position: absolute;
  padding-right: 8px;
  margin-top: auto;
  margin-bottom: auto;
  border-left: 10px solid white;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  right: 0;
  top: 0;
  bottom: 0;
`;

const ArrowLeft = styled.div`
  width: 0;
  height: 0;
  position: absolute;
  padding-left: 8px;
  margin-top: auto;
  margin-bottom: auto;
  border-right: 10px solid white;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  left: 0;
  top: 0;
  bottom: 0;
`;

export { UnitMoveButton };
